import React, { useState, useRef, useEffect } from 'react';
import { tcEventFAQ } from "../Actions/TagCommander.action"

const AccordionItem = ({ text, title }) => {


    const faqRef = useRef(null);

    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        tcEventFAQ(title, faqRef.current)
    }, [])

    const clickHandler = () => {
        setExpanded(!expanded);
    }

    return (
        <div className="faq__item">
            <button className={`faq__toggle ${expanded ? 'active' : ''}`} onClick={clickHandler} ref={faqRef} data-expanded={expanded}>
                <span className="faq__title">
                    {title}
                </span>
                <i className="faq__icon"></i>
            </button>
            <div className={`faq__panel ${expanded ? "active" : ''}`}>
                <div className="faq__content" dangerouslySetInnerHTML={{__html: text}}></div>
            </div>
        </div>
    )

}


export default AccordionItem;